// --- src/modules/procurement/procurementUtils.ts ---
// Utility functions for procurement module (Shopping List, Low Stock, Printing)

import * as XLSX from 'xlsx';
import { SupplierMap } from '../../components/types';

export interface ShoppingListItem {
  ean: string;
  name: string;
  quantity: number;
  netPrice: number;
  sellingPrice: number;
}

/**
 * Export shopping list items to Excel file
 */
export const exportShoppingListToExcel = (
  items: ShoppingListItem[],
  supplierData: SupplierMap
): void => {
  const excelData = items.map((item) => {
    const suppItem = supplierData[item.ean];
    return {
      'Termék neve': item.name,
      Vonalkód: item.ean,
      Mennyiség: item.quantity,
      'Beszerzési ár': suppItem?.netPrice || 0,
      'Eladási ár': suppItem?.sellingPrice || 0,
    };
  });

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(excelData);

  // Set column widths
  ws['!cols'] = [
    { wch: 30 }, // Termék neve
    { wch: 15 }, // Vonalkód
    { wch: 12 }, // Mennyiség
    { wch: 15 }, // Beszerzési ár
    { wch: 15 }, // Eladási ár
  ];

  XLSX.utils.book_append_sheet(wb, ws, 'Bevásárlólista');

  // Generate file and download
  const date = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `bevasarlolista_${date}.xlsx`);
};

/**
 * Format date for print header
 */
export const formatPrintDate = (): string => {
  return new Date().toISOString().slice(0, 10);
};
